module.exports = __webpack_public_path__ + "static/media/fr_my.2846c65a.png";